<template>
  <div :class="{ 'form-group': exibeLabel, 'has-error': validacao.$error }">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <BuscarSelecionar
      :id="id"
      :lista="pacientes"
      :selecionado="selecionado"
      :minimo="minimo"
      @selecionar="selecionarPaciente"
      @limpar="limparPaciente"
      @recuperar="recuperarPacientes"
    />
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import PacienteServico from '@/servicos/PacienteServico'

const pacienteServico = new PacienteServico()

export default {
  name: 'BuscarSelecionarPaciente',
  components: { BuscarSelecionar },
  props: {
    label: {
      type: String,
      default: 'Paciente',
    },
    labelSup: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'paciente',
    },
    selecionado: {
      type: Object,
      default: () => {
        return {}
      },
    },
    minimo: {
      type: Number,
      default: 0,
    },
    exibeLabel: {
      type: Boolean,
      default: true,
    },
    validacao: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      paciente: {},
      pacientes: [],
    }
  },
  methods: {
    selecionarPaciente(paciente) {
      this.$emit('selecionadoPaciente', paciente)
    },
    limparPaciente() {
      this.paciente = {}
      this.$emit('limparPaciente')
    },
    recuperarPacientes(filtro) {
      const data = {
        nome: filtro.palavra,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
        ativo: true,
      }
      pacienteServico.recuperarTodos(data).then((result) => {
        this.pacientes = result.pacientes
      })
    },
  },
}
</script>
